import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const extractErrorMessages = (state) => {
  if (!state) return ["An unknown error occurred"];

  if (typeof state === "string") {
    return [state];
  }

  if (Array.isArray(state)) {
    return state.flatMap((item) => extractErrorMessages(item));
  }

  if (typeof state === "object") {
    const keys = Object.keys(state);
    if (keys.length === GlobalConfiguration?.lengthCheckZero)
      return ["An unknown error occurred"];
    return keys.flatMap((key) => extractErrorMessages(state[key]));
  }

  return [String(state)];
};

const ReimbursementAccountError = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const createAccountHandler = () => {
    navigate("/reimbursement_account_dashboard/create_reimbursement_account", {
      replace: true,
    });
  };

  const dashboardHandler = () => {
    navigate("/reimbursement_account_dashboard", {
      replace: true,
    });
  };

  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS.ADD_BUTTON_WHITE,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
      },
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      title="Failed to create reimbursement account."
      buttonRows={buttonRows}
      hoverOption="black"
    >
      <TabsWeapperSection title="Error details">
        <>
          {extractErrorMessages(state).map((msg, index) => (
            <InfoCard
              key={index}
              bgColor="var(--negative-card)"
              rows={[{ leftTitle: msg, leftSubTitle: "Error message" }]}
            />
          ))}
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default ReimbursementAccountError;
